import { useTranslation } from 'react-i18next';
// routes
import { PATH_DASHBOARD } from 'routes/paths';
import useAuth from './useAuth';

// ----------------------------------------------------------------------
const useNavConfig = () => {
  const { t } = useTranslation();
  const { permissions } = useAuth();
  const PATIENT_PERMISSION = permissions.findIndex(item => item.functioncode === "LSTDEMANDE") !== -1; // ok + PATIENT 
  const MESSAGES_PERMISSION = false; // permissions.findIndex(item => item.functioncode === "ENCOURS") !== -1; // ok
  const ACCOUNT_PERMISSION = permissions.findIndex(item => item.functioncode === "MONCOMPTE") !== -1;  // ok a verifier MONCOMPTE ou MONPROFILE
  const DELEGATION_PERMISSION = false; // permissions.findIndex(item => item.functioncode === "DELEGATION") !== -1; // ok
  const HISTORY_PERMISSION = permissions.findIndex(item => item.functioncode === "DEMANDES") !== -1; // ok
  const ASSOCIATION_PERMISSION = false; // permissions.findIndex(item => item.functioncode === "ASSOC") !== -1; // ok
  const FUSION_PERMISSION = permissions.findIndex(item => item.functioncode === "FUSION") !== -1; // ok
  const DICO_PERMISSION = permissions.findIndex(item => item.functioncode === "DICO") !== -1; // ok
  const PARAMETER_PERMISSION = permissions.findIndex(item => item.functioncode === "PARAM") !== -1; // ok
  const PPROFILE_PERMISSION = permissions.findIndex(item => item.functioncode === "PROFILE") !== -1; // ok
  const USER_PERMISSION = permissions.findIndex(item => item.functioncode === "USER") !== -1; // ok
  const GROUP_EXAM_PERMISSION = permissions.findIndex(item => item.functioncode === "FILTRE") !== -1; // ok 
  const ACTEURS_PERMISSION = permissions.findIndex(item => item.functioncode === "UF") !== -1; // ok 
  const PREFERENCES_PERMISSION = permissions.findIndex(item => item.functioncode === "USERPREF") !== -1; // ok 

  const navList = [
    {
      title: t("menus.myActivity"),
      path: PATH_DASHBOARD.general.activity,
      children: [
        { title: t("menus.requestConsultation"), path: PATH_DASHBOARD.demandes.list, show: PATIENT_PERMISSION },
        { title: t("menus.messages"), path: PATH_DASHBOARD.message.list, show: MESSAGES_PERMISSION },
      ],
      show: PATIENT_PERMISSION || MESSAGES_PERMISSION
    },
    {
      title: t("menus.myAccess"),
      path: '',
      children: [
        { title: t("menus.myAccount"), path: PATH_DASHBOARD.account.edit, show: ACCOUNT_PERMISSION },
        { title: t("menus.preferences"), path: PATH_DASHBOARD.preferences.edit, show: PREFERENCES_PERMISSION },

        { title: t("menus.delegation"), path: PATH_DASHBOARD.delegation.list, show: DELEGATION_PERMISSION },
        { title: t("menus.consultationTracking"), path: PATH_DASHBOARD.consultation.list, show: HISTORY_PERMISSION },
      ],
      show: ACCOUNT_PERMISSION || DELEGATION_PERMISSION || HISTORY_PERMISSION

    },
    {
      title: t("menus.tools"),
      path: '',
      children: [
        { title: t("menus.association"), path: PATH_DASHBOARD.association.list, show: ASSOCIATION_PERMISSION },
        { title: t("menus.merge"), path: PATH_DASHBOARD.fusion.list, show: FUSION_PERMISSION },
      ],
      show: ASSOCIATION_PERMISSION || FUSION_PERMISSION

    },
    {
      title: t("menus.administration"),
      path: PATH_DASHBOARD.general.administration,
      children: [
        { title: t("menus.settings"), path: PATH_DASHBOARD.setting.edit, show: PARAMETER_PERMISSION },
        { title: t("menus.profiles"), path: PATH_DASHBOARD.profile.list, show: PPROFILE_PERMISSION },
        { title: t("menus.users"), path: PATH_DASHBOARD.user.list, show: USER_PERMISSION },
        { title: t("menus.examGroups"), path: PATH_DASHBOARD.groups.list, show: GROUP_EXAM_PERMISSION },
        { title: t("menus.actors"), path: PATH_DASHBOARD.actor.list, show: ACTEURS_PERMISSION },
        { title: t("menus.dictionary"), path: PATH_DASHBOARD.dictionary.list, show: DICO_PERMISSION },

      ],
      show: USER_PERMISSION || PPROFILE_PERMISSION || PARAMETER_PERMISSION || GROUP_EXAM_PERMISSION || ACTEURS_PERMISSION

    }
  ];
  const navConfig = [
    {
      subheader: 'management',
      items: [
        ...navList
      ]
    },

  ];


  return navConfig;
};

export default useNavConfig;
